import { render } from "./ShorthandUrls.vue?vue&type=template&id=5c6f11f6"
import script from "./ShorthandUrls.vue?vue&type=script&setup=true&lang=js"
export * from "./ShorthandUrls.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/ShorthandUrls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c6f11f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c6f11f6', __exports__)) {
    api.reload('5c6f11f6', __exports__)
  }
  
  module.hot.accept("./ShorthandUrls.vue?vue&type=template&id=5c6f11f6", () => {
    api.rerender('5c6f11f6', render)
  })

}


export default __exports__